<app-breadcrumb [title]="'DASHBOARD'|translate" [breadcrumb]="'DASHBOARD'|translate"></app-breadcrumb>
<!-- section start -->
<section class="section-b-space">
    <div class="container">
        <div class="row">


            <div class="col-lg-2">
                <div class="account-sidebar" (click)="_openClassToggle?_openClassToggle:openClassToggle()">
                    <a hre="javascript:void(0)" class="popup-btn">
                        {{'Shipping'|translate}}
                    </a>
                </div>
                <div class="dashboard-left" [class.open]="_openClassToggle">
                    <div class="collection-mobile-back" (click)="openClassToggle()">
                        <span class="filter-back">
                            <i class="fa fa-angle-left" aria-hidden="true"></i> {{'Back'|translate}}
                        </span>
                    </div>


                    <div class="block-content" *ngIf="isUerLogin()">
                        <ul>

                            <li [ngClass]="{'active':openNewOrder}"><a (click)="toggleNewOrder()"
                                    style="cursor: pointer;"> {{'New Order'|translate}}</a></li>


                            <li [ngClass]="{'active':openWebsite}"><a (click)="toggleWebsites()"
                                    style="cursor: pointer;"> {{'Websites'|translate}}</a></li>






                            <li [ngClass]="{'active':openOrders}"><a (click)="toggleOrders()" style="cursor: pointer;">
                                    {{'My Orders'|translate}}</a></li>

                            <!-- <li [ngClass]="{'active':openChangePassword}"><a (click)="toggleChangePassword()" style="cursor: pointer;">Change Password</a></li> -->
                            <!-- <li class="last"><a href="javascript:void(0)">Log Out</a></li> -->
                        </ul>
                    </div>
                </div>
            </div>



            <div class="col-lg-10">





                <!-- orders -->
                <div class="dashboard-right" *ngIf="openWebsite">
                    <div class="dashboard">

                        <div class="page-title">
                            <h2>{{'Websites'|translate}}</h2>
                        </div>










                        <div class="container" *ngIf="(markets$|async) as markets">
                            <div class="row">
                                <div class="col-sm " *ngFor="let market of markets"
                                    style="border: 0.5px solid rgb(230, 211, 211); margin: 2px;">
                                    <div style="margin-top: 15px;">
                                        <a (click)="openLink(market.domain)" style="cursor: pointer;">
                                            <img [src]="onDisplayImage(market.imageUrl)" class="center" />
                                            <br />
                                            <span> {{websiteName(market.domain)}}</span>
                                        </a>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>
                </div>



                <!-- orders -->
                <div class="dashboard-right" *ngIf="openOrders">
                    <div class="dashboard">

                        <div class="page-title">
                            <h2>{{'My Orders'|translate}}</h2>
                        </div>
                        <div style="margin-bottom: 15px;">
                            <input [value]="startDate" type="date" style="margin-top: 15px;" class="form-control"
                                (change)="fromDateEvent($event)">
                            <input [value]="endDate" type="date" style="margin-top: 15px;" class="form-control"
                                (change)="toDateEvent($event)">
                        </div>


                        <div class="faq-section section-b-space">
                            <div class="container">
                                <div class="row">
                                    <div class="col-sm-12" *ngIf="(shippings$ |async) as shippings">




                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <a style="cursor: pointer;">Id</a>
                                                    </th>
                                                    <th>{{'Order Date'|translate}}</th>
                                                    <th>{{'Product Name'|translate}}</th>
                                                    <th>
                                                        <a style="cursor: pointer;" (click)="sortByStatus()">Status</a>
                                                    </th>
                                                    <th>{{'Action'|translate}}</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr *ngFor="let shipping of shippings.result">
                                                    <td [routerLink]="['/shop/onlineMarket',shipping.buyerId,shipping.shippingId]"
                                                        style="cursor: pointer; color: blue; text-decoration: underline;">
                                                        {{shipping.shippingId}}</td>
                                                    <td style="width: 95px;"> {{shipping.orderDate | date:'dd-MM-yyyy'}}
                                                    </td>
                                                    <td> {{shipping.productName |textLength}}</td>
                                                    <td [ngStyle]="{'color':statusColor(shipping.shippingStatus)}">
                                                        {{shippingStatus(shipping.shippingStatus)}}</td>
                                                    <td>

                                                        <!-- <a style="cursor: pointer;" [routerLink]="'/shop/onlineMarket/{{shipping.buyerId}}/{{shipping.shippingId}}'"> -->
                                                        <a style="cursor: pointer;"
                                                            [routerLink]="['/shop/onlineMarket',shipping.buyerId,shipping.shippingId]">
                                                            <i class="fa fa-arrows-alt" aria-hidden="true"></i>

                                                        </a>

                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>




                                    </div>
                                </div>
                            </div>
                        </div>


                        <ng-container *ngIf="pagination">
                            <mat-paginator #paginator [length]="pagination.totalCount" [pageSize]="pagination.pageSize"
                                [pageSizeOptions]="[20,40,100]" [showFirstLastButtons]="true"
                                (page)="switchPage($event)">
                            </mat-paginator>
                        </ng-container>


                    </div>
                </div>


                <!-- new order -->
                <div class="dashboard-right" *ngIf="openNewOrder">
                    <div class="dashboard">



                        <div class="col-lg-4" style="margin-bottom: 20px; margin-left: 33%;">
                            <div class="theme-card">

                                <!-- Row 0 -->
                                <div class="form-row">
                                    <!-- Email -->
                                    <div class="col-md-12">
                                        <!-- <label for="review">Image</label> -->
                                        <!-- <input type="file" #fileInput accept="image/png, image/jpeg" mat-flat-button (change)="onFileSelected($event)"> -->
                                        <span class="btn btn-file" style="background: rgb(156, 40, 40);
                                        color: khaki;font-weight: bold;
                                         border-radius: 5px;
                                         margin-bottom: 5px;">{{'Please add picture your item.'|translate}}<input
                                                type="file" #fileInput accept="image/png, image/jpeg"
                                                (change)="onFileSelected($event)"></span>

                                    </div>
                                </div>


                                <!-- Row 0 -->
                                <div class="form-row">


                                    <!-- fullName -->
                                    <div class="col-md-6" *ngIf="imagesUrls.length>0 && imagesUrls">
                                        <img style="width: 350px; height: 350px;" [src]="imagesUrls[0]">
                                    </div>

                                </div>

                            </div>
                        </div>

                        <!-- <pre>
                            {{onlineShoppingForm.value |json}}
                        </pre> -->

                        <div class="box-account box-info">


                            <div class="theme-card">
                                <form class="theme-form" [formGroup]="onlineShoppingForm"
                                    (ngSubmit)="onSumbitForm(onlineShoppingForm.value)" autocomplete="off">


                                    <!-- Row 1 -->
                                    <div class="form-row">

                                        <!-- product Name -->
                                        <div class="col-md-6">
                                            <label for="review">{{'Product Name'|translate}}</label>
                                            <input type="text" [formControlName]="'productName'" class="form-control"
                                                id="productName" [placeholder]="'Product Name'|translate" required="">
                                            <div class="error-messages">
                                                <ng-container *ngFor="let error of error_messages.productName">
                                                    <div class="error-message"
                                                        *ngIf="getProductName?.hasError(error.type) && 
                                                                                                      (getProductName?.dirty || getProductName?.touched)">
                                                        {{ error.message |translate}}
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>




                                        <!-- Link -->
                                        <div class="col-md-6">
                                            <label for="review">{{'Link'|translate}}</label>
                                            <input type="text" [formControlName]="'link'" class="form-control" id="link"
                                                [placeholder]="'Link'|translate" required="">
                                            <div class="error-messages">
                                                <ng-container *ngFor="let error of error_messages.link">
                                                    <div class="error-message"
                                                        *ngIf="getLink?.hasError(error.type) && (getLink?.dirty || getLink?.touched)">
                                                        {{ error.message |translate }}
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>

                                    </div>




                                    <!-- Row 2 -->
                                    <div class="form-row" style="margin-top: 20px;">

                                        <!-- Quantity -->
                                        <div class="col-md-6">
                                            <label for="review">{{'Quantity'|translate}}</label>
                                            <input type="number" [formControlName]="'quantity'" class="form-control"
                                                id="quantity" [placeholder]="'Quantity'|translate" required="">
                                            <div class="error-messages">
                                                <ng-container *ngFor="let error of error_messages.quantity">
                                                    <div class="error-message"
                                                        *ngIf="getQuantity?.hasError(error.type) && 
                                                                                                  (getQuantity?.dirty || getQuantity?.touched)">
                                                        {{ error.message |translate }}
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>


                                        <div class="col-md-6">
                                            <label for="review">{{'Item Price'|translate}}</label>
                                            <input type="number" [formControlName]="'itemPrice'" class="form-control"
                                                id="itemPrice" [placeholder]="'Item Price'|translate" required="">
                                            <div class="error-messages">
                                                <ng-container *ngFor="let error of error_messages.itemPrice">
                                                    <div class="error-message"
                                                        *ngIf="getItemPrice?.hasError(error.type) && 
                                                                                                  (getItemPrice?.dirty || getItemPrice?.touched)">
                                                        {{ error.message |translate}}
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>

                                        <!-- product Name -->
                                        <!-- <div class="col-md-6">
                                            <label for="review">Product Type</label>
                                            <input type="text" [formControlName]="'type'" class="form-control" id="type" placeholder="Type">
                                        </div> -->
                                    </div>



                                    <!-- Row 3 -->
                                    <div class="form-row" style="margin-top: 20px;">

                                        <!-- Color -->
                                        <div class="col-md-6">
                                            <label for="review">{{'Color'|translate}}</label>
                                            <input type="text" [formControlName]="'color'" class="form-control"
                                                id="color" [placeholder]="'Color'|translate">
                                        </div>


                                        <!-- Size -->
                                        <div class="col-md-6">
                                            <label for="review">{{'Size'|translate}}</label>
                                            <input type="text" [formControlName]="'size'" class="form-control" id="type"
                                                [placeholder]="'Size'|translate">
                                        </div>

                                    </div>



                                    <!-- Row 5 -->
                                    <div class="input-group " style="margin-top: 20px; margin-bottom: -20px;">
                                        <label for="review">{{'Item Weight by LBS (Pound)'|translate}}</label><br />
                                    </div>
                                    <!-- Row 5 -->
                                    <div class="input-group  mb-3" style="margin-top: 20px;">
                                        <input type="number" [formControlName]="'weight'" min="1" class="form-control"
                                            id="weight" [placeholder]="'Item Weight'|translate">
                                        <div class="error-messages">
                                            <ng-container *ngFor="let error of error_messages.weight">
                                                <div class="error-message"
                                                    *ngIf="getWeight?.hasError(error.type) && 
                                                                                                                      (getWeight?.dirty || getWeight?.touched)">
                                                    {{ error.message |translate }}
                                                </div>
                                            </ng-container>
                                        </div>
                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-outline-secondary"
                                                style="width: 173px;" [hidden]="couponDisabled"
                                                (click)="showCalculation()">
                                                {{'Height * Length * Width'|translate }} </button>
                                        </div>
                                    </div>



                                    <!-- Row 3 -->
                                    <div class="form-row" style="margin-top: 20px;" *ngIf="showCalc">

                                        <!-- height -->
                                        <div class="col-md-4">
                                            <label for="review">{{'Height'|translate}}</label>
                                            <input type="number" [formControlName]="'height'" #heightValue
                                                (input)="onHeightInput(heightValue.value)" class="form-control"
                                                id="height" [placeholder]="'Height'|translate">
                                        </div>


                                        <!-- length -->
                                        <div class="col-md-4">
                                            <label for="review">{{'Length'|translate}}</label>
                                            <input type="number" #lengthValue (input)="onLengthInput(lengthValue.value)"
                                                [formControlName]="'length'" class="form-control" id="length"
                                                [placeholder]="'Length'|translate">
                                        </div>


                                        <!-- width -->
                                        <div class="col-md-4">
                                            <label for="review">{{'Width'|translate}}</label>
                                            <input type="number" #widthValue (input)="onWidthInput(widthValue.value)"
                                                [formControlName]="'width'" class="form-control" id="width"
                                                [placeholder]="'Width'|translate">
                                        </div>



                                    </div>









                                    <!-- Row 4 -->
                                    <div class="form-row" style="margin-top: 20px;">

                                        <!-- Note -->
                                        <div class="col-md-12">
                                            <label for="review">{{'Note'|translate}}</label>
                                            <input type="textarea" [formControlName]="'note'" class="form-control"
                                                id="note" [placeholder]="'Note'|translate">
                                        </div>
                                    </div>


                                    <!-- Row 5 -->
                                    <div class="input-group mb-3" style="margin-top: 20px;">
                                        <input type="text" class="form-control" [disabled]="couponDisabled" #couponQuery
                                            [placeholder]="'Coupon'|translate">
                                        <div class="input-group-append">
                                            <button *ngIf="!isCouponApplied" type="button"
                                                class="btn btn-outline-secondary" style="width: 163px;"
                                                [hidden]="couponDisabled" [disabled]="couponDisabled"
                                                (click)="applyCoupon(couponQuery.value)">
                                                {{'Apply Coupon'|translate}} </button>

                                            <button *ngIf="isCouponApplied" type="button"
                                                class="btn btn-outline-secondary" style="width: 200px; color: brown;"
                                                [hidden]="couponDisabled" [disabled]="couponDisabled"
                                                (click)="applyCoupon(couponQuery.value)">
                                                {{'Remove'|translate }} </button>

                                        </div>
                                    </div>

                                    <!-- Row 6 -->
                                    <div class="form-row" style="margin-top: 20px;">
                                        <h6>
                                            <input type="checkbox" [formControlName]="'expressShipping'"> {{'Express
                                            Shipping $1.90 per Lbs'|translate}}
                                        </h6>
                                    </div>

                                    <!-- Row 7 -->
                                    <div class="form-row" style="margin-top: 0px; margin-left: 20px;">
                                        <h6>
                                            <label> * {{'Express shipping (preferred): 12 to 14 business
                                                days'|translate}} </label>
                                        </h6>
                                    </div>
                                    <!-- Row 7 -->
                                    <div class="form-row" style="margin-top: -5px; margin-left: 20px;">
                                        <h6>
                                            <label> * {{'Economy shipping: 18 to 22 business days'|translate}} </label>
                                        </h6>
                                    </div>


                                    <!-- Row 7 -->
                                    <div class="form-row" style="margin-top: 10px;">
                                        <h6>
                                            <input type="checkbox"
                                                [formControlName]="'insurance'">{{'Insurance'|translate}} $2.90
                                        </h6>
                                    </div>



                                    <!-- Row 8 -->
                                    <div class="form-row" style="margin-top: 10px; margin-left: 40%;">
                                        <div class="col-md-6">
                                            <!-- <input type="submit" #saveButton class="btn btn-solid" [disabled]="!customerForm.valid" /> -->
                                            <input type="submit" class="btn btn-solid" [value]="'REQUEST'|translate"
                                                [disabled]="!onlineShoppingForm.valid" />
                                        </div>
                                    </div>





                                </form>

                                <div>
                                    <h6>* {{'Regular Membership: $8 per pound 0 monthly payment'|translate}} </h6>
                                    <h6>* {{'Business membership: $7 per pound 29.99 monthly payment'|translate}}
                                    </h6>
                                    <h6>* {{'Our commission $1'|translate}}</h6>
                                </div>

                            </div>


                        </div>
                    </div>
                </div>






            </div>
        </div>
    </div>
</section>
<!-- section end -->